<template>
  <v-combobox
    :value="selectedItem"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :loading="loading"
    :items="items"
    :search-input.sync="search"
    hide-no-data
    item-value="id"
    item-text="name"
    clearable
    return-object
    no-filter
  >
    <template v-slot:append-item>
      <v-list-item disabled v-if="showBottomMessage">
        <v-list-item-content>
          <v-list-item-title>
            Type to filter more records...
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item></template
    ></v-combobox
  >
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "ProductCategoryField",
  props: {
    value: Object,
    preventId: Number,
    status: { type: String, required: false }
  },
  data: () => ({
    showBottomMessage: true,
    selectedItem: null,
    loading: false,
    search: null,
    items: [],
    rules: [
      v => {
        if (!!v && !v.id) {
          return "Invalid selection";
        } else {
          return true;
        }
      }
    ]
  }),
  methods: {
    onInput(obj) {
      if (obj && obj.id) {
        this.$emit("input", obj);
      }
    }
  },
  watch: {
    search(val) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      let filters = {};
      filters.keyword = val;
      filters.isEffective = this.status;

      ApiService.post("/api/productCategories/search", filters).then(({ data }) => {
        this.loading = false;
        let fullItems = data.content;
        if (this.preventId && this.preventId > 0) {
          fullItems = fullItems.reduce((acc, cur) => {
            if (cur.id != this.preventId) {
              acc.push(cur);
            }
            return acc;
          }, []);
        }
        if (fullItems.length > 9) {
          this.items = fullItems.slice(0, 9);
          this.showBottomMessage = true;
        } else {
          this.items = fullItems;
          this.showBottomMessage = false;
        }
      });
    }
  },
  mounted() {
    this.selectedItem = this.value;
    this.search = "";
  }
};
</script>
